import React from 'react';

const ErrorMsg = ({ errorText, mainClassName }: any) => <p className={`text-xs font-normal text-fgErrorPrimary dark:fgErrorPrimary mt-1.5 empty:hidden ${mainClassName}`}>{errorText}</p>;

export default ErrorMsg;
